import { ReactNode } from "react";
import { toast } from "sonner";

import { ToastContext } from "./context";
import { Toast, ToastProps } from "./Toast";

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const customToast = (toastProps: Omit<ToastProps, "toastId">) => {
    return toast.custom(
      (t) => {
        return <Toast toastId={t} {...toastProps} />;
      },
      {
        position: "top-center",
      },
    );
  };

  return (
    <ToastContext.Provider
      value={{
        toast: customToast,
      }}
    >
      {children}
    </ToastContext.Provider>
  );
};
